import React, { useRef } from "react";
import { cloud } from "../../../utility/constants/assetsManager";
import { useSnackbar } from "notistack";

const UploadBtn = ({
  onChange,
  accept,
  filesize,
  imageTypeArray = ["png", "jpg", "img", "pdf", "image", "jpeg", "mp4"],
}) => {
  const fileInputRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleFileChange = (event) => {
    event.preventDefault();

    const file = event.target.files[0];
    console.log(file, "FIle upload ");

    // Validate file type
    if (!file || imageTypeArray.includes(file.type)) {
      enqueueSnackbar(`Please upload only ${imageTypeArray.join(", ")}`, {
        variant: "error",
      });
      return;
    }

    // Call onChange callback with the file
    onChange(file);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <img
        src={cloud}
        alt="Upload"
        style={{ width: "50px", height: "50px", cursor: "pointer" }}
        onClick={handleClick}
      />
      <input
        id="fileInput"
        style={{
          width: "100%",
          height: "100%",
          zIndex: -1,
          position: "absolute",
        }}
        type="file"
        onChange={handleFileChange}
        ref={fileInputRef}
        accept={accept}
      />
    </div>
  );
};

export default UploadBtn;
